export const formatDurationMinutes = (totalMinutes = 0, options = {}) => {
  const { shortUnderHour = false } = options;
  const roundedMinutes = Math.round(Number(totalMinutes) || 0);

  if (roundedMinutes >= 1440) {
    const days = Math.floor(roundedMinutes / 1440);
    const remainingMinutes = roundedMinutes % 1440;
    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;

    return `${days}d ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  }

  if (roundedMinutes >= 60) {
    const hours = Math.floor(roundedMinutes / 60);
    const minutes = roundedMinutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  }

  return shortUnderHour ? `${roundedMinutes}m` : `${roundedMinutes}`;
};
